<app-share-button ></app-share-button>

<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        लॉगिन प्रोसेस QR के माध्यम से   </h2>
                </div>
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg"
                            style="width: 30px;" alt=""></button>
                </div> -->
                
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2>परिचय </h2>
                    <label for="" class="mt-2">यह दस्तावेज़ PayG रेसलर अकाउंट में वेब के माध्यम से सीधे QR स्कैनिंग से लॉगिन करने के लिए एक स्टेप-बाय-स्टेप गाइड प्रदान करता है। सेटअप प्रक्रिया को सुचारू रूप से पूरा करने के लिए निर्देशों का ध्यानपूर्वक पालन करें। </label>
                </div>
                <div class="col-md-12 mt-5  " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">


                    <h4 class="mt-2"><b>स्टेप 1: PayG RMS ऐप डाउनलोड करें </b></h4>
                    <label for="">शुरू करने के लिए, आपको अपने मोबाइल फोन पर PayG RMS ऐप डाउनलोड करना होगा। यह ऐप एंड्रॉइड और iOS दोनों डिवाइसों के लिए उपलब्ध है।</label>
                    <div class="row">
                        <div class="col-md-12 mt-3 " style="text-align: center;">
                            <img src="./assets/reseller(1).svg" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <h4 class="mt-4"><b>एंड्रॉइड यूज़र्स के लिए: </b></h4>
                    <div class="row">
                        <label for=""><b>डाउनलोड लिंक:</b> <a
                                style="text-decoration: none; color: rgb(4, 151, 242);"
                                href="https://play.google.com/store/apps/details?id=com.paygdigitals.rms&hl=en">
                                https://play.google.com/store/apps/details?id=com.paygdigitals.rms&hl=en</a> पर क्लिक करें और Google Play Store से PayG RMS ऐप डाउनलोड करें।</label>
                            <h4 class="mt-4"><b>iOS यूज़र्स के लिए:  </b></h4>
                        <div class="row">
                            <label for=""><b>डाउनलोड लिंक:</b>  <a
                                    style="text-decoration: none; color: rgb(4, 151, 242);"
                                    href="https://apps.apple.com/us/app/payg-rms/id6463256232">
                                    https://apps.apple.com/us/app/payg-rms/id6463256232</a>पर क्लिक करें और App Store में जाकर PayG RMS ऐप डाउनलोड करें।</label>



                        <h4 class="mt-4"><b>QR कोड:</b></h4>
                        <label for="">नीचे दिए गए QR कोड को अपने डिवाइस के कैमरा या QR कोड स्कैनर ऐप से स्कैन करें, ताकि आप सीधे App Store पर जाएं और ऐप डाउनलोड कर सकें।</label>
                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/QR code both.svg" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        
                            <!-- <h4 class="mt-4"><b>QR Code </b></h4>
                            <label for="">Scan the QR code below using your device’s camera or a QR code scanner app to
                                be directed to the App Store </label>
                            <div class="row">
                                <div class="col-md-12 mt-3" style="text-align: center;">
                                    <img src="./assets/RMS_PayG_ iOS_QR.png" width="200px" height="200px"
                                        alt="">
                                </div>
                            </div> -->

                        </div>
                        <h4 class="mt-4"><b>स्टेप 2: ऐप खोलें और लॉगिन करें </b></h4>
                        <label for="">ऐप सफलतापूर्वक डाउनलोड होने के बाद, अपने मोबाइल डिवाइस पर PayG RMS ऐप को ढूंढें और उसे खोलने के लिए टैप करें। </label>
                        <label for=""><b>लॉगिन:</b> अपने यूज़र क्रेडेंशियल्स (यूज़रनेम और पासवर्ड) को निर्धारित फ़ील्ड्स में दर्ज करें। सुनिश्चित करें कि आपकी जानकारी सही ढंग से भरी हो, ताकि लॉगिन में कोई समस्या न हो।</label>

                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/reseller(4).svg" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <h4 class="mt-4"><b>स्टेप 3: प्रोफाइल सेक्शन तक पहुँचें</b></h4>
                        <label for="">लॉगिन करने के बाद, आपको मोबाइल ऐप के डैशबोर्ड पर भेजा जाएगा। प्रोफाइल आइकन को ढूंढें, जो आमतौर पर डैशबोर्ड के बाएं तरफ स्थित होता है। </label>

                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/reseller(5).svg" width="300px" height="500px" alt="">
                            </div>
                        </div>

                        <h4 class="mt-4"><b>स्टेप 4: लॉगिन करने के लिए वेब स्कैनर का चयन करें </b></h4>
                        <label for="">वेब स्कैनर ऑप्शन: "Web Scanner to Login" ऑप्शन को ढूंढें और चुनें। इस फीचर के जरिए आप QR कोड स्कैन करके वेब पर लॉगिन कर सकते हैं।</label>

                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/reseller(6).svg" width="300px" height="500px" alt="">
                            </div>
                        </div>

                        <h4 class="mt-4"><b>स्टेप 5: QR कोड स्कैन करें </b></h4>
                        <h4>वेब प्लेटफॉर्म पर लॉगिन प्रक्रिया को पूरा करने के लिए: </h4>
                        <label for="">अपने मोबाइल डिवाइस के कैमरे को वेब पेज पर दिखाए गए QR कोड के ऊपर रखें। सुनिश्चित करें कि QR कोड कैमरे के व्यूफाइंडर में अच्छी तरह से केंद्रित हो, ताकि स्कैनिंग सही तरीके से हो सके।                     </label>
                        <div class="row">
                            <div class="col-md-12 mt-3" style="text-align: center;">
                                <img src="./assets/reseler(7).png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <label class="mt-3" for="">QR कोड सफलतापूर्वक स्कैन होने के बाद, आप स्वतः ही PayG RMS वेब प्लेटफॉर्म पर लॉगिन हो जाएंगे, जिससे आपको सभी उपलब्ध कार्यक्षमताओं तक पहुँच प्राप्त हो जाएगी </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/reseller(8).svg" width="100%"
                                    height="100%" alt="">
                            </div>
                        </div>

                        <h4 class="mt-4">निष्कर </h4>
                        <label for="">आपने PayG RMS ऐप के लिए प्रारंभिक सेटअप और लॉगिन प्रक्रिया पूरी कर ली है। यदि इस प्रक्रिया के दौरान आपको कोई समस्या आती है, तो कृपया ऐप के सपोर्ट सेक्शन को देखें या अधिक सहायता के लिए कस्टमर सपोर्ट से संपर्क करें।  </label>
                    </div>
                </div>
            </div>
        </div>
    </div>

        <div class="col-md-4 hide-tbl content2 ">
            <div class="card crd p-4">
                <div class="row">
                    <div class="col-md-12">
                        <h5>
                            विषयसूची:                        </h5>

                    </div>
                    <div class="col-md-12 mt-2">
                        <!-- <a href="#1">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                        alt=""> &nbsp;</div>
                                <div class="col-md-10">
                                    <span class="videoHover" style="cursor: pointer;"
                                        [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                        >
                                        Introduction to
                                        Payment Gateways
                                    </span>
                                  
                                </div>
                            </div>
                        </a> -->
                    </div>
                    <div class="col-md-12 ">
                        <a href="#2">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                    &nbsp;
                                </div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                        (click)="color('2')">परिचय  </span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-12 ">
                        <a href="#3">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                    &nbsp;
                                </div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                        (click)="color('3')">
                                        लॉगिन प्रोसेस</span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <!-- <div class="col-md-12 ">
                        <a href="#4">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                    &nbsp;
                                </div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                        (click)="color('4')">Benefits of Being a Reseller </span>

                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-12 ">
                        <a href="#5">
                            <div class="row">
                                <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                    &nbsp;
                                </div>
                                <div class="col-md-10">
                                    <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                        (click)="color('5')"> How Resellers Can Benefit from PayG</span>

                                </div>
                            </div>
                        </a>
                    </div> -->

                </div>
            </div>
        </div>
        <div class="col-md-9 hide ft-9">
            <hr>
            <div class=" row crd">
                <div class="col-md-8    ">
                    <a [routerLink]="['/registration-process']"><button class="btn btn-color"
                            (click)="menues('Creating Profile')"> <img src="./assets/Arrow 3.svg" alt="">
                            &nbsp;पंजीकरण प्रक्रिया
                            &nbsp;</button></a>
                </div>
                <div class="col-md-4    ">
                    <a [routerLink]="['/manual-login']"> <button class="btn btn-color">मैनुअल लॉगिन 
                            &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
                </div>
            </div>
        </div>
</div>